module.exports = __webpack_public_path__ + "img/4.10bf1f58.jpg";